import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import alertService from '../services/alert.service'
import workOrderApi, { WorkOrderData } from '../apis/workOrder.api'
import Card from '../components/Card'
import CardButton from '../components/CardButton'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import PageHeading from '../components/PageHeading'
import TableVertical, {
  TableVerticalHeader
} from '../components/TableVertical'
import ItemMaterials from '../partials/ItemMaterials'

interface WorkOrderRouteState {
  id: number
}

interface WorkOrderProps
  extends RouteComponentProps<any, any, WorkOrderRouteState> {}

interface WorkOrderState {
  workOrder: WorkOrderData | null
}

class WorkOrder extends Component<WorkOrderProps, WorkOrderState> {
  headers: TableVerticalHeader[] = [
    { heading: i18n('Work order'), path: 'code' },
    { heading: i18n('Line number'), path: 'line' },
    { heading: i18n('Sales order'), path: 'salesOrder' },
    { heading: i18n('Item code'), path: 'item.code' },
    { heading: i18n('Item description'), path: 'item.description' },
    { heading: i18n('Quantity'), path: 'quantity.amount' },
    { heading: i18n('Produced quantity'), path: 'quantity.produced' },
    { heading: i18n('Remaining quantity'), path: 'quantity.remaining' },
    { heading: i18n('Adjustment quantity'), path: 'quantity.adjustment' },
    { heading: i18n("Production date"),
      path: 'produceAt',
      date: true,
      tooltip: 'createdUser.username'
    },
    { heading: i18n("Created at"),
      path: 'createdAt',
      date: true,
      tooltip: 'createdUser.username'
    },
    { heading: i18n("Updated at"),
      path: 'updatedAt',
      date: true,
      tooltip: 'updatedUser.username'
    }
  ]

  constructor (props: WorkOrderProps) {
    super(props)
    this.state = {
      workOrder: null
    }
    this.handleEditClick = this.handleEditClick.bind(this)
  }

  get id () {
    return this.props.location.state.id
  }

  get itemMaterials () {
    const { workOrder } = this.state
    return workOrder && workOrder.item && workOrder.quantity && (
      <ItemMaterials
        id={workOrder.item.id}
        quantity={workOrder.quantity.remaining} />
    )
  }

  materialDeficitAlert () {
    const { workOrder } = this.state
    if (workOrder && workOrder.materialStockout) {
      const message = 'Please note this work order has a material deficit'
      alertService.instruction(message)
    }
  }

  readWorkOrder () {
    workOrderApi.read(this.id, workOrder => {
      if (!workOrder) return
      this.setState({ workOrder }, () => {
        this.materialDeficitAlert()
      })
    })
  }

  handleEditClick () {
    const pathname = routes.workOrderEdit
    const state = { id: this.id }
    this.props.history.push({ pathname, state })
  }

  componentDidMount () {
    this.readWorkOrder()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="half">
          <Card>
            <PageHeading
              text={i18n("View Work Order")}
              doc='work-orders-view-work-order' />
            <TableVertical
              headers={this.headers}
              data={this.state.workOrder} />
            {this.itemMaterials}
            <CardButton
              proceedText={i18n("Edit")}
              cancelText={i18n("Back")}
              onProceedClick={this.handleEditClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(WorkOrder)
